import { Platform } from 'react-native';

type TSources = 'pwa' | 'android' | 'ios' | 'windows';

interface IOrderMeta {
    source: TSources
}

const useOrderMeta = (): string => {
    
    let order_meta: IOrderMeta = {
        source: 'pwa'
    };

    switch (Platform.OS) {
        case 'web':
            order_meta.source = 'pwa';
            break;

        case 'android':
            order_meta.source = 'android'
            break;
    
        case 'ios':
            order_meta.source = 'ios'
            break;
    
        case 'windows':
            order_meta.source = 'windows'
            break;
    
        default:
            break;
    }

    return JSON.stringify(order_meta)
}

export default useOrderMeta